import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Radio } from "lucide-react";
import api from "@/lib/api";
import { t } from "@/lib/i18n";
import { timeAgo } from "@/lib/format";

export default function ActivityTicker() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    const load = () =>
      api.get("/activity/recent?limit=15").then((r) => {
        if (alive) setItems(r.data.items || []);
      }).catch(() => {});
    load();
    const id = setInterval(load, 45_000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  if (!items || items.length === 0) return null;
  // Duplicate for seamless loop
  const loop = [...items, ...items];

  return (
    <div className="border-y border-border bg-card/70 backdrop-blur-sm overflow-hidden" data-testid="activity-ticker">
      <div className="max-w-6xl mx-auto flex items-stretch">
        <div className="shrink-0 flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground text-xs font-eng" dir="ltr">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-accent"></span>
          </span>
          <span className="urdu-naskh text-sm font-semibold">{t.activityLabel}</span>
        </div>
        <div className="ticker-mask flex-1 overflow-hidden py-2">
          <div className="ticker-track">
            {loop.map((it, i) => (
              <Link
                key={i + it.post_id}
                to={`/t/${it.thread_id}#post-${it.post_id}`}
                className="inline-flex items-center gap-2 text-sm hover:text-primary"
              >
                <span className="urdu-naskh font-semibold text-primary">{it.username}</span>
                <span className="urdu-naskh text-muted-foreground">نے</span>
                <span className="urdu-naskh line-clamp-1 max-w-md">{it.thread_title}</span>
                <span className="urdu-naskh text-muted-foreground">میں {it.is_op ? "موضوع شروع کیا" : "جواب دیا"}</span>
                <span className="text-[11px] font-eng text-muted-foreground opacity-70">· {timeAgo(it.created_at)}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
